import { render, staticRenderFns } from "./ImagesPagination.vue?vue&type=template&id=1c42bc5a&"
import script from "./ImagesPagination.vue?vue&type=script&lang=js&"
export * from "./ImagesPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports